import React from 'react';

import { useStyledTheme } from 'hooks/useStyledTheme';

import SvgIcon from '../SvgIcon';

const IconLastStep = (props: React.SVGAttributes<SVGSVGElement>) => {
  const theme = useStyledTheme();

  return (
    <SvgIcon viewBox="0 0 287 266" {...props}>
      <path stroke="#C2D2DA" strokeWidth="2" fill="#FFF" d="M38 31h248v168H38z" />
      <g fill="#C2D2DA">
        <rect x="47" y="37" width="4" height="4" rx="2" />
        <rect x="55" y="37" width="4" height="4" rx="2" />
        <rect x="63" y="37" width="4" height="4" rx="2" />
      </g>
      <g fill="#E5EBED">
        <ellipse cx="206.5" cy="263" rx="57.5" ry="3" />
        <ellipse cx="27.5" cy="243" rx="27.5" ry="3" />
        <path d="M39 46h246v152H39z" />
      </g>
      <g stroke={theme.colors.fountainBlue} strokeWidth="2" strokeLinecap="square" fill="#FFF">
        <circle cx="29" cy="191" r="26" stroke="none" />
        <path d="M33 216.7a26.1 26.1 0 0 1-4 .3 26 26 0 1 1 26-26m-16 20v8c0 3.3 5.4 6 12 6s12-2.7 12-6v-8" />
        <path d="M39 203v8c0 3.3 5.4 6 12 6s12-2.7 12-6v-8" />
        <path d="M63 203c0 2.1-2.3 4.1-6 5.2s-8.3 1-12 0c-3.7-1-6-3-6-5.2 0-2.1 2.3-4.1 6-5.2s8.3-1 12 0c3.7 1 6 3 6 5.2zm-34-26v14H14" />
      </g>
      <g fill={theme.colors.fountainBlue}>
        <circle fill="#FFF" cx="114" cy="37" r="24" />
        <path d="M135.3 28.4l1.9-.8A25 25 0 0 1 139 37a25 25 0 1 1-15.6-23.2l-.8 1.9A23 23 0 0 0 114 14a23 23 0 1 0 23 23 23 23 0 0 0-1.7-8.6z" />
        <path d="M126 37a12 12 0 1 0-24 0 12 12 0 0 0 24 0zm2 0a14 14 0 1 1-28 0 14 14 0 0 1 28 0z" />
        <path d="M114 38.4l-1.4-1.4L146 3.6l1.4 1.4z" />
        <path d="M151 13.4l-9.7 9.6-11.1-2.3-2.3-11.1 9.7-9.6 2.4 11.2 11 2.2zm-12.9-.6L136.4 4l-6.4 6.3 1.7 8.8 8.9 1.8 6.3-6.3-8.8-1.8z" />
      </g>
      <path
        d="M71 66a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-4 10a4 4 0 0 1 4-4 4 4 0 0 1 4 4v1a4 4 0 0 1-4 4 4 4 0 0 1-4-4v-1zm4 12a10 10 0 0 1-6.4-2.3A5 5 0 0 1 69 83h4c2 0 3.6 1 4.4 2.7A10 10 0 0 1 71 88z"
        fill="#C2D2DA"
      />
      <path
        fill="#C2D2DA"
        opacity=".3"
        d="M59 96h24v4H59zm0 8h24v4H59zm0 20h24v4H59zm0 8h24v4H59zm0 8h24v4H59zm0 8h24v4H59zm0 8h24v4H59zm0 8h24v4H59zm46-93h55v15h-55zm0 33h45v7h-45zm0 20h45v7h-45zm0 16h45v7h-45zm0 16h45v7h-45z"
      />
      <path d="M144 46h141v146a6 6 0 0 1-6 6H150a6 6 0 0 1-6-6V46z" fill="#E5EBED" />
      <path
        stroke={theme.colors.fountainBlue}
        strokeWidth="2"
        fill="#DEE9EE"
        d="M160 61h114v158H160z"
      />
      <g stroke={theme.colors.accent} strokeWidth="2" fill="none">
        <path d="M237 81h-87v158h114V108l-27-27z" fill="#FFF" />
        <path d="M219.5 173.5h12.9l15.6-20m-83 42l17.9-12.5h17l7.7-6.5" />
        <path d="M213 186v20m0-52v14m6 6a6 6 0 1 1-12 0 6 6 0 0 1 12 0z" strokeLinecap="square" />
        <path d="M236 81v27.7h28" />
      </g>
      <path
        fill={theme.colors.accent}
        d="M165 106h24v4h-24zm0 22h84v2h-84zm0 10h84v2h-84zm60 80h24v3h-24z"
      />
    </SvgIcon>
  );
};

export default IconLastStep;
